import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const eventTypeBaseEndpoint = ENDPOINTS.EVENTTYPE;

// Event API using Catering Package endpoints
export const eventTypeApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["eventType"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getEventType: builder.query({
        query: (payload) => `${eventTypeBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "eventType" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),

      addEventType: builder.mutation({
        query: (requestData) => ({
          url: `${eventTypeBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "eventType" }],
      }),
      updateEventType: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${eventTypeBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "eventType" }],
      }),
      deleteEventType: builder.mutation({
        query: (id) => ({
          url: `${eventTypeBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "eventType" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
    useAddEventTypeMutation,
    useGetEventTypeQuery,
    useUpdateEventTypeMutation,
    useDeleteEventTypeMutation,
} = eventTypeApi;
